module.exports = __webpack_public_path__ + "static/img/bankong.16e1054a.png";